/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Session_KickerInputs */

const en_plan_session_kicker = /** @type {(inputs: Plan_Session_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook session`)
};

const de_plan_session_kicker = /** @type {(inputs: Plan_Session_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsession`)
};

/**
* | output |
* | --- |
* | "Cook session" |
*
* @param {Plan_Session_KickerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_session_kicker = /** @type {((inputs?: Plan_Session_KickerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_KickerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_session_kicker(inputs)
	return en_plan_session_kicker(inputs)
});